import ObjectCache from './CacheService';
import LogicBaseRelationshipApi from '../server/LogicBaseRelationshipApi';
import UserAccount from '../UserAccount';
import LogicBaseRelationship from '../../models/logicbaserelationship';

class LogicBaseRelationshipCache extends ObjectCache {
  api = LogicBaseRelationshipApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseRelationship(results._id, results.fr, results.fe, results.r, results.lst);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseRelationshipCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
